/** Survives React Strict Mode remount when ?create=1 is cleared from the URL. */
let pendingProjectCreate: { leadId: string | null } | null = null;

export function captureProjectCreateDeepLink(leadId: string | null): void {
  pendingProjectCreate = { leadId };
}

/** Peek without consuming — Strict Mode remount needs a second read. */
export function peekProjectCreateDeepLink(): { leadId: string | null } | null {
  return pendingProjectCreate;
}

export function clearProjectCreateDeepLink(): void {
  pendingProjectCreate = null;
}
